import React from 'react';
import styles from './members.module.scss';
import yen from '../../../assets/images/YenJungIcon.webp'
import ting from '../../../assets/images/TingEnIcon.webp'

const members = () => (
  <div className={styles.wrapper}>
    <div className={[styles.container].join(' ')}>
      <div className={[styles.title, 'row', 'mx-0'].join(' ')}>
        <h3>開發團隊</h3>
      </div>
      <div className={[styles.textBlock, 'row'].join(' ')}>
        <div className={[styles.textBlockInner, 'col-xl-6', 'col-12', 'row', 'mx-0'].join(' ')}>
          <div className={styles.text}>
            <p>分帳龍寶寶為我們工作之餘的自行發起的專案，如想暸解其中的不專業開發過程歡迎閱讀我們的文章</p>
          </div>
        </div>
        <div className={[styles.memberBlocks, 'col-xl-6', 'col-12', 'row', 'mx-0'].join(' ')}>
          <a href='https://cdragon.medium.com/%E5%88%86%E5%B8%B3%E9%BE%8D%E5%AF%B6%E5%AF%B6-linebot-%E9%96%8B%E7%99%BC%E9%9A%A8%E4%BE%BF%E5%AF%AB%E4%B9%8B%E4%B8%80-c99444683983' target="_blank" className={[styles.member, 'row', 'col-md-6', 'col-12', 'mx-0'].join(' ')}>
            <div className={styles.imgBlock}>
              <img src={yen} alt="" />
            </div>
            <div className={styles.memberText}>
              <h5>YenJung</h5>
              <h6>Developer</h6>
            </div>
          </a>
          <a href='https://tingenwei.medium.com/sideproject-linebot-%E5%88%86%E5%B8%B3%E9%BE%8D%E5%AF%B6%E5%AF%B6%E8%A3%BD%E4%BD%9C%E7%B4%80%E9%8C%84-26643e1095cd' target="_blank" className={[styles.member, 'row', 'col-md-6', 'col-12', 'mx-0'].join(' ')}>
            <div className={styles.imgBlock}>
              <img src={ting} alt="" />
            </div>
            <div className={styles.memberText}>
              <h5>TN</h5>
              <h6>Product Designer</h6>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
)

export default members;
